export const SET_NETWORK_ACTIVITY = 'SET_NETWORK_ACTIVITY';
export const SET_SERVER_UNAVAILABLE = 'SET_SERVER_UNAVAILABLE';

export const setNetworkActivityAction = isFetching => ({
  type: SET_NETWORK_ACTIVITY,
  isFetching
});

export const setServerUnavailableAction = payload => ({ type: SET_SERVER_UNAVAILABLE, payload });
